import React from 'react'

function JustExploreCardIcon() {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M120 60.0089C120 93.1483 93.1306 120 59.9911 120C26.8517 120 0 93.1306 0 60.0089C0 26.8871 26.8694 0 60.0089 0C93.1483 0 120.018 26.8694 120.018 60.0089H120Z"
        className="fill"
        fill="#4A4A4A"
        fillRule="nonzero"
      />
      <path
        d="M70.9202 42.5269C71.115 42.9342 71.2744 43.3416 71.4161 43.7667C71.2744 43.3416 71.115 42.9165 70.9202 42.5269Z"
        fill="#003A78"
      />
      <path
        d="M71.4325 43.8376C71.5565 44.2627 71.645 44.6878 71.7159 45.1129C71.645 44.6701 71.5565 44.245 71.4325 43.8376Z"
        fill="#003A78"
      />
      <path
        d="M60.5757 40.5078C60.7174 40.6672 60.8414 40.8621 60.9653 41.0569C60.8591 40.8621 60.7351 40.6849 60.5757 40.5078Z"
        fill="white"
      />
      <path
        d="M71.4502 23.9114C71.4502 29.0833 67.2701 33.2634 62.0981 33.2634C56.9262 33.2634 52.7461 29.0833 52.7461 23.9114C52.7461 18.7394 56.9262 14.5593 62.0981 14.5593C67.2701 14.5593 71.4502 18.7571 71.4502 23.9114Z"
        fill="white"
      />
      <path
        d="M88.986 69.1483L80.1122 58.8221L74.9934 51.011L73.8066 62.6656L74.8694 64.0294L84.1328 72.8678C85.4613 74.1254 86.772 74.7453 88.4546 73.5763C90.2435 72.301 90.0133 70.3704 89.0037 69.1483H88.986Z"
        fill="white"
      />
      <path
        d="M60.1867 48.921C60.2576 48.7793 60.7712 47.7874 60.8952 47.3978C61.0192 47.0258 61.1255 46.6538 61.2317 46.2996C61.7277 44.4221 61.7454 42.828 61.2494 41.6236C61.1786 41.4288 61.0723 41.2339 60.9838 41.0568C60.8598 40.862 60.7535 40.6848 60.5941 40.5077C59.5314 39.3033 57.7601 39.0022 56.7328 39.4273C56.5557 39.4981 56.3786 39.5513 56.1838 39.5867C54.4834 40.9682 53.7395 42.6155 53.6863 42.7572L52.0391 46.8664L48.4967 55.7048L47.2214 58.8753L42.935 77.7564C42.1557 81.4937 43.7675 82.2022 44.3874 82.4856C44.7771 82.6627 45.5387 82.893 46.3889 82.5033C47.2922 82.0959 48.0007 81.0863 48.4613 79.5985L49.7188 75.5424L52.0391 68.0856L53.8458 62.3114L60.2044 48.921H60.1867Z"
        fill="white"
      />
      <path
        d="M52.3209 37.2838H48.318V34.2019H44.7755V37.3192C40.8257 37.3547 37.8324 40.5606 37.8324 44.5104V49.6646H37.2833C34.9453 49.6646 33.1741 51.5598 33.1741 53.8801V54.4823H38.1158V58.0248H33.1741V64.8263C33.1741 67.1643 35.0693 69.0418 37.3896 69.0418H40.8612C40.9674 69.1126 41.0914 69.1834 41.1977 69.2543L43.8368 57.6528C43.8368 57.6528 49.9829 39.5333 52.2855 37.2661L52.3209 37.2838Z"
        fill="white"
      />
      <path
        d="M77.313 94.1936C77.313 94.1936 69.2008 72.8327 69.2008 72.7087L71.8576 46.7249C71.8576 46.2821 71.8222 45.8393 71.7691 45.3965C71.7691 45.308 71.7514 45.2194 71.7336 45.1309C71.6628 44.688 71.5742 44.263 71.4503 43.8556C71.4503 43.8202 71.4325 43.8024 71.4148 43.767C71.2731 43.3419 71.1137 42.9168 70.9189 42.5272C70.9189 42.5094 70.9012 42.4917 70.8835 42.474C69.8207 40.3131 67.8901 38.5951 65.127 37.7449C66.9336 40.2777 68.5455 45.2903 63.7986 53.7921C63.3204 54.66 62.3993 55.1559 61.4783 55.1559C61.372 55.1559 61.2657 55.1205 61.1418 55.1205L57.0502 63.7464L53.5078 75.1353L65.3395 95.6991L62.9661 117.751C62.8244 118.583 62.8067 119.309 62.913 119.965C66.4908 119.788 69.9801 119.292 73.3809 118.512C73.3809 118.512 73.3809 118.512 73.3809 118.495L77.2776 94.229L77.313 94.1936Z"
        fill="white"
      />
      <path
        d="M59.8494 93.166L52.1092 79.7224L51.8258 80.6434C51.3476 82.1844 50.6922 83.3003 49.9837 84.0973L47.8937 93.3608L34.1313 114.137C37.4789 115.749 41.0214 117.042 44.6878 118.016L58.1491 97.346L59.8671 93.166H59.8494Z"
        fill="white"
      />
    </svg>
  )
}

export default JustExploreCardIcon
